/* eslint-disable react/prop-types */
import React from 'react';
import PartenaireBlock from 'components/success/PartenaireBlock';
import PartenaireSubBlock from 'components/success/PartenaireSubBlock';

export default function PartenaireRgeBlock() {
  const title =
    'Vous souhaitez bénéficier de l’offre Hellio Prime Déduite ?\nComment ça se passe ?';
  return (
    <PartenaireBlock title={title}>
      <PartenaireSubBlock number={1} title="Nous étudions votre projet">
        Nos équipes analysent votre demande pour comprendre vos besoins et vous
        proposer la meilleure solution.
      </PartenaireSubBlock>
      <PartenaireSubBlock
        number={2}
        title="Un artisan RGE partenaire Hellio prend contact avec vous"
      >
        Un partenaire Hellio, certifié RGE et proche de chez vous, vous appelle
        pour affiner votre projet et planifier une visite si besoin.
      </PartenaireSubBlock>
      <PartenaireSubBlock
        number={3}
        title="Vous recevez un devis avec les aides déduites"
      >
        Pas d’avance de frais&nbsp;: la prime Hellio est directement intégrée
        dans votre devis. Clair, net et sans surprise.
      </PartenaireSubBlock>
      <PartenaireSubBlock
        number={4}
        title="Les travaux démarrent, vous économisez"
      >
        Une fois le devis validé, place à la concrétisation. Les travaux peuvent
        commencer, et vous profitez de votre confort… et de vos économies&nbsp;!
      </PartenaireSubBlock>
    </PartenaireBlock>
  );
}
